<template>
  <v-menu
    v-model="menuOpen"
    location="bottom end"
    :close-on-click="false"
    :close-on-content-click="false"
    max-width="400px"
  >
    <template #activator="{ props }">
      <v-btn v-bind="props">
        <v-icon class="mr-2">mdi-calendar</v-icon>
        <span>{{ filterLabel || 'Date Filters' }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Filter by Date
        <v-spacer />
        <v-btn icon @click="menuOpen = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <CommonDatePicker
              label="From"
              :enter-date="dateStart"
              clearable
              outlined
              dense
              @updateDate="updateStartDate"
            />
          </v-col>
          <v-col cols="6">
            <CommonDatePicker
              label="To"
              :enter-date="dateEnd"
              clearable
              outlined
              dense
              @updateDate="updateEndDate"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn class="cancel" variant="outlined" @click="clearFilter">Clear</v-btn>
        <v-spacer />
        <v-btn
          class="apply"
          color="primary"
          data-track="report.open-invoices-dates.apply"
          @click="applyFilter"
        >
          Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { formatDate } from '@/utils/filters';
import { Nullable } from '@/utils/types';

import CommonDatePicker from '@/components/common-components/pickers/CommonDatePicker.vue';

export default defineComponent({
  name: 'OpenInvoicesDateFilter',

  components: { CommonDatePicker },

  props: {
    dateStart: {
      type: String,
      default: '',
    },
    dateEnd: {
      type: String,
      default: '',
    },
  },

  emits: ['fetch', 'update:dateEnd', 'update:dateStart'],

  data () {
    return {
      menuOpen: false,
    };
  },

  computed: {
    filterLabel (): string {
      if (this.dateStart && this.dateEnd) {
        return `${formatDate(this.dateStart)} - ${formatDate(this.dateEnd)}`;
      }

      if (this.dateStart) {
        return `From ${formatDate(this.dateStart)}`;
      }

      if (this.dateEnd) {
        return `To ${formatDate(this.dateEnd)}`;
      }

      return '';
    },
  },

  methods: {
    updateStartDate (date: Nullable<string>): void {
      this.$emit('update:dateStart', date);
    },
    updateEndDate (date: Nullable<string>): void {
      this.$emit('update:dateEnd', date);
    },
    clearFilter (): void {
      this.updateStartDate(null);
      this.updateEndDate(null);
    },
    applyFilter () {
      this.menuOpen = false;
      this.$emit('fetch');
    },
  }
})
</script>
